import { objectFieldConverter, ObjectFieldView } from "./objectFieldView";
import { booleanFieldConverter, BooleanFieldView } from "./booleanFieldView";
import { dateFieldConverter, DateFieldView } from "./dateFieldView";
import { logoFieldConverter, LogoFieldView } from "./logoFieldView";
import {
  multilineCharFieldConverter,
  MultilineCharFieldView,
} from "./multilineCharFieldView";
import {
  multipleChoiceFieldConverter,
  MultipleChoiceFieldView,
} from "./multipleChoiceFieldView";
import { charFieldConverter, CharFieldView } from "./charFieldView";
import { fileFieldConverter, FileFieldView } from "./fileFieldView";
import { numberFieldConverter, NumberFieldView } from "./numberFieldView";
import { choiceFieldConverter, ChoiceFieldView } from "./choiceFieldView";
import { defaultFieldConverter, DefaultFieldView } from "./defaultFieldView";
import { linkFieldConverter, LinkFieldView } from "./linkFieldView";
import {
  manyRelatedFieldConverter,
  ManyRelatedFieldView,
} from "./manyRelatedFieldView";
import {
  primaryKeyRelatedFieldConverter,
  PrimaryKeyRelatedFieldView,
} from "./primaryKeyRelatedFieldView";
import { listFieldConverter, ListFieldView } from "./listFieldView";
import {
  percentageFieldConverter,
  PercentageFieldView,
} from "./percentageFieldView";

const viewFields = {
  booleanField: {
    Component: BooleanFieldView,
    converter: booleanFieldConverter,
    djangoFields: ["BooleanField"],
  },
  charField: {
    Component: CharFieldView,
    converter: charFieldConverter,
    djangoFields: ["CharField"],
  },
  multilineCharField: {
    Component: MultilineCharFieldView,
    converter: multilineCharFieldConverter,
    djangoFields: ["MyAutoExpandTextField"],
  },
  choiceField: {
    Component: ChoiceFieldView,
    converter: choiceFieldConverter,
    djangoFields: ["ChoiceField"],
  },
  dateField: {
    Component: DateFieldView,
    converter: dateFieldConverter,
    djangoFields: ["DateField"],
  },
  emailField: {
    Component: CharFieldView,
    converter: charFieldConverter,
    djangoFields: ["EmailField"],
  },
  fileField: {
    Component: FileFieldView,
    converter: fileFieldConverter,
    djangoFields: ["FileField", "MyFileField"],
  },
  floatField: {
    Component: CharFieldView,
    converter: numberFieldConverter,
    djangoFields: ["FloatField"],
  },
  imageField: {
    Component: FileFieldView,
    converter: fileFieldConverter,
    djangoFields: ["ImageField"],
  },
  integerField: {
    Component: NumberFieldView,
    converter: numberFieldConverter,
    djangoFields: ["IntegerField"],
  },
  link: {
    Component: LinkFieldView,
    converter: linkFieldConverter,
    djangoFields: [],
  },
  logo: {
    Component: LogoFieldView,
    converter: logoFieldConverter,
    djangoFields: [],
  },
  manyRelatedField: {
    Component: ManyRelatedFieldView,
    converter: manyRelatedFieldConverter,
    djangoFields: ["ManyRelatedField"],
  },
  multipleChoiceField: {
    Component: MultipleChoiceFieldView,
    converter: multipleChoiceFieldConverter,
    djangoFields: [],
  },
  objectField: {
    Component: ObjectFieldView,
    converter: objectFieldConverter,
    djangoFields: ["ObjectField"],
  },
  primaryKeyRelatedField: {
    Component: PrimaryKeyRelatedFieldView,
    converter: primaryKeyRelatedFieldConverter,
    djangoFields: ["PrimaryKeyRelatedField"],
  },
  slugField: {
    Component: CharFieldView,
    converter: charFieldConverter,
    djangoFields: ["SlugField"],
  },
  listField: {
    Component: ListFieldView,
    converter: listFieldConverter,
    djangoFields: ["ListSerializer"],
  },
  percentageField: {
    Component: PercentageFieldView,
    converter: percentageFieldConverter,
    djangoFields: ["MyPercentageField"],
  },
  //default to charField
  default: {
    Component: DefaultFieldView,
    converter: defaultFieldConverter,
    djangoFields: [
      "JSONField",
      "DateTimeField",
      "SlugRelatedField",
      "SerializerMethodField",
    ],
  },
};

export default viewFields;
